import React from 'react'

import '../../styles/componentsStyles/Browse/Suggestions.scss'

// import Sug from "../../assets/images/sug.JPG"
import Code from "../../assets/images/thum.jpg"
import Logo from "../../assets/images/codemmit-logo.png"

const Suggestions = () => {

    const suggestions = [
        {
            thumbnail: Code,
            title: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Explicabo, necessitatibus.",
            channelName: "DocZ",
            likes: "1.5k",
            views: "2k",
            logo: Logo

        },
        {
            thumbnail: Code,
            title: "Lorem ipsum dolor sit, amet csdkff sjdf isdf snfsn fksdjf, dfsd olms.",
            channelName: "Codemmit",
            likes: "1.5k",
            views: "2k",
            logo: Logo
        },
        {
            thumbnail: Code,
            title: "Lorem olor sit, amet consectetur adipisicing eli, necessitatibus.",
            channelName: "Poster",
            likes: "1.5k",
            views: "2k",
            logo: Logo
        },
        {
            thumbnail: Code,
            title: "Lorem olor sit, amet consectetur adipisicing eli, necessitatibus.",
            channelName: "Poster",
            likes: "1.5k",
            views: "2k",
            logo: Logo
        },
        {
            thumbnail: Code,
            title: "Lorem olor sit, amet consectetur adipisicing eli, necessitatibus.",
            channelName: "Poster",
            likes: "1.5k",
            views: "2k",
            logo: Logo
        },
        {
            thumbnail: Code,
            title: "Lorem olor sit, amet consectetur adipisicing eli, necessitatibus.",
            channelName: "Poster",
            likes: "1.5k",
            views: "2k",
            logo: Logo
        },
        {
            thumbnail: Code,
            title: "Lorem olor sit, amet consectetur adipisicing eli, necessitatibus.",
            channelName: "Poster",
            likes: "1.5k",
            views: "2k",
            logo: Logo
        },
    ]
    return (
        <div className='suggestions'>
            {
                suggestions.map(suggestion => <div className="suggestions__card" key={suggestion.channelName}>
                    <div className="suggestions__thumbnail-container">
                        <img className="suggestions__thumbnail" src={suggestion.thumbnail} alt="thumbnail" />
                    </div>
                    <div className="suggestions__card-details">
                        <p className='suggestions__title'>
                            {suggestion.title.substring(0, 80)}
                            {
                                (suggestion.title.length > 80) ? <span>...</span> : ""
                            }</p>

                        <p className='suggestions__stats'>
                            <span>{suggestion.views} views &#183; {suggestion.likes} likes </span>
                        </p>
                        <p className="suggestions__channel-name">
                            <img src={suggestion.logo} alt="logo" />
                            {suggestion.channelName}
                        </p>
                    </div>
                </div>)
            }

        </div>
    )
}

export default Suggestions